module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAAGUlEQVR4XmOYw8B2hhLMgC5AKh41YDAYAADDX7cBro+/WQAAAABJRU5ErkJggg=="